import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons';

function createMarkup(htmlContent) {
  return { __html: htmlContent };
}

function TranscriptOverlay({ visible, onClose, trackTitle, transcriptContent }) {
  return (
    <Modal show={visible} onHide={onClose} size="lg" centered className="transcript-modal">
      <Modal.Header closeButton className="transcript-header">
        <Modal.Title className="d-flex align-items-center gap-2 transcript-title">
          <FontAwesomeIcon icon={faClosedCaptioning} aria-hidden="true" className="transcript-icon" />
          <span>{trackTitle || 'Transcript'}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="transcript-body">
        <div
          className="transcript-content"
          dangerouslySetInnerHTML={createMarkup(transcriptContent)}
        />
      </Modal.Body>
      <Modal.Footer className="transcript-footer">
        <Button variant="secondary" onClick={onClose} className="transcript-close-button">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TranscriptOverlay;
